/* Product card content layout, shared by the collection grid and any other
   section that opts in with the .mdm-coll class.

   card-product.liquid is a shared snippet, so the colour label is rendered on
   the <li> and slotted into the card here, along with the theme's own swatch
   row. mdm-collection.css then places them: name | swatches on the first line,
   colour name under the name, price beneath. */
(function () {
  function titleCase(s) {
    return String(s || '').trim().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function place() {
    document.querySelectorAll('.mdm-coll [data-mdm-card-colour]').forEach(function (label) {
      var li = label.closest('.grid__item, .card-wrapper, .splide__slide');
      if (!li) return;

      /* Two .card__information blocks exist per card. Pick the one that
         carries the price — that is the block shown under the image.
         Visibility is not a safe test: the other is hidden only by the theme's
         own display rule, which section CSS can override. */
      var infos = li.querySelectorAll('.card__information');
      var info = null;
      for (var i = 0; i < infos.length; i++) {
        if (infos[i].querySelector('.card-information, .price')) { info = infos[i]; break; }
      }
      if (!info) info = infos[infos.length - 1];
      if (!info) return;
      info.classList.add('mdm-card-info');

      var swatches = li.querySelector('.product-form__input--swatches');
      if (swatches && swatches.parentElement !== info) info.appendChild(swatches);
      info.classList.toggle('mdm-has-swatches', !!swatches);
      if (label.parentElement !== info) info.appendChild(label);
    });
    queueAlign();
  }

  /* Cards sharing a row must share a baseline. When one product name wraps to
     two lines and its neighbour's does not, the taller name pushes that card's
     colour name and price down by a line and the two read as misaligned.
     Reserve the tallest name of each row on every card in that row.

     Per row rather than across the whole grid on purpose: reserving two lines
     everywhere would add a blank line under the ~80% of names that fit on one,
     which is white space the grid does not need. */
  var alignQueued = false;

  function alignRows() {
    alignQueued = false;
    var heads = document.querySelectorAll('.mdm-coll .mdm-card-info > .card__heading');
    if (!heads.length) return;

    var i, rows = {}, key;
    /* Clear first so a name that no longer wraps (wider viewport, different
       font) releases the height it used to need. */
    for (i = 0; i < heads.length; i++) heads[i].style.minHeight = '';

    for (i = 0; i < heads.length; i++) {
      /* Every card in a row sits under an image of the same height, so the
         heading tops match to the pixel and make a reliable row key. */
      key = String(Math.round(heads[i].getBoundingClientRect().top + window.pageYOffset));
      (rows[key] || (rows[key] = [])).push(heads[i]);
    }

    Object.keys(rows).forEach(function (k) {
      var group = rows[k];
      if (group.length < 2) return;
      var tallest = 0;
      group.forEach(function (h) {
        var height = h.getBoundingClientRect().height;
        if (height > tallest) tallest = height;
      });
      group.forEach(function (h) { h.style.minHeight = tallest + 'px'; });
    });
  }

  function queueAlign() {
    if (alignQueued) return;
    alignQueued = true;
    requestAnimationFrame(alignRows);
  }

  /* The label follows whichever swatch was last chosen. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.mdm-coll .color-swatch');
    if (!sw) return;
    var li = sw.closest('.grid__item, .card-wrapper, .splide__slide');
    var label = li && li.querySelector('[data-mdm-card-colour]');
    if (label && sw.dataset.swatchValue) label.textContent = titleCase(sw.dataset.swatchValue);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();

  /* Sliders and section re-renders bring in fresh cards. */
  new MutationObserver(place).observe(document.documentElement, { childList: true, subtree: true });

  /* Wrapping changes with the column width, and again once the real font
     replaces the fallback. */
  window.addEventListener('resize', queueAlign);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueAlign);

  window.MDMPlaceCards = place;
  window.MDMAlignCardRows = alignRows;
})();
